import { css } from '@linaria/core';
import { styled } from '@linaria/react';
import { theming } from 'styles/utils';
import { textSmall } from 'styles/typography';
export const wrapper = "omponents__ui_library__Formik__components__FormElements__Input__components__RuledPasswordInput__RuledPasswordInput_styles_ts-wrapper-w1qdypzm";
export const percentLineContainer = "omponents__ui_library__Formik__components__FormElements__Input__components__RuledPasswordInput__RuledPasswordInput_styles_ts-percentLineContainer-p1wb27qv";
export const percentLineOuter = "omponents__ui_library__Formik__components__FormElements__Input__components__RuledPasswordInput__RuledPasswordInput_styles_ts-percentLineOuter-pmq8pqe";
export const PercentLineInner = /*#__PURE__*/styled("div")({
  name: "PercentLineInner",
  class: "omponents__ui_library__Formik__components__FormElements__Input__components__RuledPasswordInput__RuledPasswordInput_styles_ts-PercentLineInner-p1eofjo4",
  vars: {
    "p1eofjo4-0": [props => props.percent, "%"]
  }
});
export const rulesContainer = "omponents__ui_library__Formik__components__FormElements__Input__components__RuledPasswordInput__RuledPasswordInput_styles_ts-rulesContainer-rmbz396";
export const rulesElement = `${"omponents__ui_library__Formik__components__FormElements__Input__components__RuledPasswordInput__RuledPasswordInput_styles_ts-rulesElement-r3ddw7b"}
${textSmall}
`;

require("./RuledPasswordInput.styles.linaria.module.css!=!../../../../../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./RuledPasswordInput.styles.ts");